// Components
const SocialClubEditableComment = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "social-club-editable-comment" */ "@/app/views/main-view/social-club/components/social-club-editable-comment/social-club-editable-comment.vue"
	)
const ModalSocialClubEditPost = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-social-club-edit-post"*/ "@/app/views/main-view/social-club/components/modals/modal-social-club-edit-post/modal-social-club-edit-post.vue"
	)
const ModalReactionSummary = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-reaction-summary"*/ "@/app/views/main-view/social-club/components/modals/modal-reaction-summary/modal-reaction-summary.vue"
	)

// Third Party libraries
const VueGallerySlideshow = () =>
	import(/* webpackPrefetch: true, webpackChunkName: "vue-gallery-slideshow"*/ "vue-gallery-slideshow")
const vue2Dropzone = () => import(/*webpackPrefetch: true, webpackChunkName: "vue-dropzone"*/ "vue2-dropzone")
const VueLightboxAdvanced = () =>
	import(/*webpackPrefetch: true, webpackChunkName: "vue-lightbox-advanced"*/ "vue-lightbox-advanced")

// Services
import CommentService from "@/app/services/main/comment/comment-service.js"
import ContentReactionService from "@/app/services/main/content-reaction/content-reaction-service.js"

// Mixins
import { socialClubMixins } from "@/app/mixins/components/social-club-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { imageCompressorMixins } from "@/app/mixins/utils/image-compressor-mixins"

// Constants
import { STATUS_CODES, ERROR_MSG, CONTENT_TYPE } from "@/app/constants/status-constants"

// Bus
import EventBus from "@/app/bus/event-bus.js"

export default {
	name: "SocialClubFeeds",
	components: {
		SocialClubEditableComment,
		ModalSocialClubEditPost,
		vueDropZone: vue2Dropzone,
		VueGallerySlideshow,
		ModalReactionSummary,
		VueLightboxAdvanced,
	},
	mixins: [socialClubMixins, userMixins, toastMessageMixins, dateMixins, imageCompressorMixins],
	props: {
		feedContent: {
			type: Object,
		},
		screen: {
			type: String,
		},
	},
	data() {
		return {
			commentInput: "",
			index: null,
			commentIndex: null,
			dropOptions: {
				url: "https://httpbin.org/post", // endpoint where files needs to be sent. Currently mocked.
				thumbnailWidth: null,
				thumbnailHeight: null,
				maxFilesize: 20,
				maxThumbnailFilesize: 20,
				acceptedFiles: ".svg, .png, .jpg, .gif, .jpeg",
				headers: { Authorization: "Bearer mock authorization" },
				uploadMultiple: false,
				autoProcessQueue: false,
				maxFiles: 1,
				addRemoveLinks: true,
				ignoreHiddenFiles: true,
				clickable: `#dropZonePostCommentUploader-${this.feedContent.id}`,
				dictFileTooBig: "File Size must not exceed 20 MB.",
				dictInvalidFileType: "Unsupported File Format.",
				dictRemoveFile: "<i class='fa fa-close'></i>",
			},
			fileCount: 0,
			firstOpenFlag: true,
			firstOpenCommentFlag: true,
			comments: [],
			isCreatingComment: false,
			options: {
				limit: 3,
				offset: 0,
			},
			commentCount: 0,
			commentShowStatus: "more",
			seeMoreClicked: false,
			isFetchingComments: false,
			isSavingReaction: false,
			contentType: CONTENT_TYPE,
			reactions: [
				{
					id: 1,
					type: require("@/assets/images/social-club/like.png"),
					active: false,
				},
				{
					id: 2,
					type: require("@/assets/images/social-club/heart.png"),
					active: false,
				},
				{
					id: 3,
					type: require("@/assets/images/social-club/haha.png"),
					active: false,
				},
				{
					id: 4,
					type: require("@/assets/images/social-club/wow.png"),
					active: false,
				},
				{
					id: 5,
					type: require("@/assets/images/social-club/crying.png"),
					active: false,
				},
				{
					id: 6,
					type: require("@/assets/images/social-club/mad.png"),
					active: false,
				},
			],
			reactionDetails: {
				totalReactionCount: 0,
				countPerReactionType: [],
			},
		}
	},
	computed: {
		getPosterInitials() {
			const { firstName, lastName } = this.feedContent

			let userInitials = ""

			if (firstName && lastName) {
				userInitials = `${firstName.charAt(0)}${lastName.charAt(0)}`
			}

			return userInitials
		},
		getMediaLinks() {
			return this.feedContent.mediaFiles.map(({ location }) => location)
		},
		getDisplayingComments() {
			if (this.commentShowStatus === "more") {
				return this.comments.filter((_, index) => index < 3)
			}

			return this.comments
		},
		getCommentShowStatus() {
			return this.commentShowStatus === "more" ? "View more comments" : "View less comments"
		},
		getActiveReaction() {
			let activeReaction = this.reactions.find((reaction) => reaction.active)

			return activeReaction
				? activeReaction
				: {
						type: require("@/assets/images/social-club/like.png"),
						active: false,
				  }
		},
		getActiveGroup() {
			return this.$store.getters.getActiveGroup
		},
		isDashboard() {
			return this.$route.path === "/dashboard" ? true : false
		},
	},
	created() {
		if (!this.feedContent.newPost) {
			this.getComments()
		}

		window.addEventListener("scroll", this.closeDropdownReaction)
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.closeDropdownReaction)
	},
	methods: {
		onClicked(v) {
			this.index = v
		},
		async getComments() {
			if (this.screen === "group") {
				const { reactions } = this.feedContent
				this.reactionDetails = reactions
				if (reactions.customerReactionType) {
					this.setActiveReaction({ id: reactions.customerReactionType }, true)
				}
				return
			}

			if (!this.isFetchingComments) {
				this.isFetchingComments = true

				const {
					data: { comments, commentCount, reactions },
				} = await CommentService.getComments({
					offset: this.options.offset,
					limit: this.options.limit,
					postId: this.feedContent.id,
				})

				this.commentCount = commentCount
				this.comments = this.comments.concat(comments)
				this.reactionDetails = reactions

				// Set active raction if there is any
				if (reactions.customerReactionType) {
					this.setActiveReaction({ id: reactions.customerReactionType }, true)
				}

				this.isFetchingComments = false
			}
		},
		updatePostCallback(updatedPost) {
			this.$emit("updatePostCallback", updatedPost)
		},
		updateCommentCallback(updatedComment) {
			this.comments = this.comments.map((comment) => {
				if (comment.id === updatedComment.id) {
					return updatedComment
				}

				return comment
			})
		},
		deleteCommentCallback(deletedComment) {
			this.comments = this.comments.filter((comment) => deletedComment.id !== comment.id)
			if (!this.seeMoreClicked) {
				this.options.offset -= 1
			}
		},
		seeMoreOrLessClicked() {
			if (
				this.commentCount > 3 &&
				this.comments.length < this.commentCount &&
				this.commentShowStatus === "more"
			) {
				this.options = {
					limit: 0,
					offset: this.options.offset + 3,
				}

				this.getComments()
			}

			this.seeMoreClicked = true
			this.commentShowStatus = this.commentShowStatus === "more" ? "less" : "more"
		},
		getCommenterInitials(commenter) {
			return `${commenter.firstName.charAt(0)}${commenter.lastName.charAt(0)}`
		},
		async submitComment() {
			const image = this.$refs.postCommentDropZone.getAcceptedFiles()
			const hasImage = image.length > 0
			const hasInput = this.commentInput !== ""

			if ((hasInput || hasImage) && !this.isCreatingComment) {
				const commentDetails = {
					formDetails: { postId: this.feedContent.id },
				}

				if (hasImage) {
					console.log("Compressing photo....")
					commentDetails.image = await this.compressImage(image[0])
				}

				if (hasInput) {
					commentDetails.formDetails.content = this.commentInput
				}

				this.isCreatingComment = true

				const res = await CommentService.saveComment(commentDetails)

				if (res.status === STATUS_CODES.SUCCESS) {
					const {
						data: { comment },
					} = res

					// Clean post input state
					this.$refs.postCommentDropZone.removeAllFiles()
					this.commentInput = ""
					this.comments = [comment].concat(this.comments)
					this.$store.commit("setHasComment", false)
					this.$store.commit("setHasCommentImage", false)

					// If the user hasn't clicked the see more
					// increment the offset so
					// that the pagination is correct
					if (!this.seeMoreClicked) {
						this.options.offset += 1
					}

					this.isCreatingComment = false
				} else {
					const { ERROR_SAVE_COMMENT } = this.toastMessages.comment()
					this.showAPIErrorToast(ERROR_SAVE_COMMENT, res)
					this.isCreatingComment = false
				}
			}
		},
		openEditPostModal() {
			this.$refs.modalEditPost.openModal()
		},
		triggerHasComment() {
			const payload = !!this.commentInput.trim()

			this.$store.commit("setHasComment", payload)
		},
		triggerHasCommentImage() {
			const hasChange = this.fileCount > 0

			this.$store.commit("setHasCommentImage", hasChange)
		},
		onAddFile() {
			this.fileCount++

			this.triggerHasCommentImage()
		},
		onRemoveFile() {
			this.fileCount--

			this.triggerHasCommentImage()
		},
		onDropZoneError(file, message) {
			if (message !== ERROR_MSG.DROPZONE_UPLOAD_CANCELLED) {
				this.showCustomErrorToast(ERROR_MSG.DROPZONE_UPLOAD_ERROR_TITLE, message)
			}

			this.$refs.postCommentDropZone.removeFile(file)
		},
		handleOpenFlag(flag) {
			this.firstOpenFlag = flag
		},
		handleCommentOpenFlag(flag) {
			this.firstOpenCommentFlag = flag
		},
		async showDeleteAlert() {
			const { value } = await this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
				imageAlt: "Confirm Dog",
				titleText: `Delete Post`,
				html: `<p>Are you sure you want to delete this post?</p>`,
				confirmButtonText: "Confirm",
				cancelButtonText: "Cancel",
				showCancelButton: true,
				customClass: {
					header: "header-social-club",
					title: "title-social-club",
				},
				reverseButtons: true,
			})

			if (value) {
				this.$emit("deletePostCallback", this.feedContent.id)
			}
		},
		deletePostCallback(id) {
			this.$emit("deletePostCallback", id)
		},
		emitReportContent(reportContent) {
			const { content } = reportContent
			// set the breedId for comment
			// content["breedId"] = this.feedContent.breedId;
			this.$emit("showReportContentModal", reportContent)
		},
		makeAppFixed(isFixed) {
			EventBus.$emit("makeRootAppFixed", isFixed)
		},
		setActiveReaction(selectedReaction, fromApi) {
			if (selectedReaction.id === this.getActiveReaction.id) {
				selectedReaction.active = false
				this.reactionDetails.totalReactionCount -= 1

				this.reactionDetails.countPerReactionType = this.reactionDetails.countPerReactionType.map(
					(reaction) => {
						// subtract count to the selected reaction
						if (reaction.reactionTypeId === selectedReaction.id) {
							reaction.count = parseInt(reaction.count) - 1
						}

						return reaction
					}
				)
			} else {
				if (!this.getActiveReaction.active && !fromApi) {
					this.reactionDetails.totalReactionCount = parseInt(this.reactionDetails.totalReactionCount) + 1
				}

				if (!fromApi) {
					let notFound = true

					this.reactionDetails.countPerReactionType = this.reactionDetails.countPerReactionType.map(
						(reaction) => {
							// add count to selected reaction
							if (reaction.reactionTypeId === selectedReaction.id) {
								notFound = false
								reaction.count = parseInt(reaction.count) + 1
							}

							// subtract count to currently active reaction
							if (reaction.reactionTypeId === this.getActiveReaction.id) {
								reaction.count = parseInt(reaction.count) - 1
							}

							return reaction
						}
					)

					if (notFound) {
						this.reactionDetails.countPerReactionType.push({
							count: 1,
							reactionTypeId: selectedReaction.id,
						})
					}
				}

				this.reactions = this.reactions.map((reaction) => {
					// set the selected reaction to active
					reaction.active = reaction.id === selectedReaction.id

					return reaction
				})
			}
		},
		saveReactionContent(selectedReaction) {
			const reactionDetails = {
				contentId: this.feedContent.id,
				contentType: this.contentType.POST,
				groupId: this.getActiveGroup.id,
				reactionTypeId: selectedReaction.id,
			}

			this.isSavingReaction = true

			ContentReactionService.saveReaction(reactionDetails)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.setActiveReaction(selectedReaction)
					} else {
						const { ERROR_SAVING_REACTION } = this.toastMessages.reaction()
						this.showAPIErrorToast(ERROR_SAVING_REACTION, res)
					}

					this.isSavingReaction = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isSavingReaction = false
				})
		},
		closeDropdownReaction() {
			// check reaction dropdown if open then close
			if (this.$refs[`meatballReactionDropdown-${this.feedContent.id}`].ariaExpanded === "true") {
				this.$refs[`meatballReactionDropdown-${this.feedContent.id}`].click()
			}
		},
		showModalReactionSummary() {
			this.$refs.reactionSummaryModal.openModal()
		},
		showPostComponent() {
			this.$store.commit("setPostContent", this.feedContent)
			this.$router.push("/post")
		},
	},
}
